module.exports = require('./PageGallery');



/** WEBPACK FOOTER **
 ** ./demo/src/pages/gallery/index.js
 **/